export class MultiLangTextListener {
    public static bindLanguageChanged(onLanguageChanged: () => void): void {
        document.addEventListener("languageChanged", onLanguageChanged);
    }
}
